// extracted by css-extract-rspack-plugin
export default {"row":"IE8Sr","section":"I84p7","column":"RQKp6","list":"GYEtZ"};